import VimeoVideo from '../components/VimeoVideo';
import AnimateIn from './AnimateIn';

const VideoHero = ({ component }) => {
  return (
    <AnimateIn className="video-hero">
      <VimeoVideo
        component={component}
        fullWidth
      />
      <div className="video-hero__overlay">
        <div className="g-row">
          <div className="video-hero__section">{component.section}</div>
          <h1
            className="t-large c-white"
            dangerouslySetInnerHTML={{ __html: component.title }}
          />
        </div>
      </div>
    </AnimateIn>
  );
};

export default VideoHero;
